// ================================================================
// PROPRIETARY & CONFIDENTIAL — Miskulin Technologies Inc.
// Copyright (c) 2026 Miskulin Technologies. All rights reserved.
// ================================================================
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';
import { init as initProtection } from './utils/protection';

initProtection();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
